var _tspan, _tspan2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveOnCampusStat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f4f47b4e-c244-4526-b788-babc0f914277",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321.3 165.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 121.69)",
    style: {
      fontSize: 146,
      fill: "#f6b11c",
      fontFamily: "futura-pt",
      fontWeight: 700
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.049998662243150686em"
    }
  }, "6"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 94.9,
    y: 0
  }, "6%"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5 126.37)",
    style: {
      fontSize: 146,
      fill: "none",
      stroke: "#002b51",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fontFamily: "futura-pt",
      fontWeight: 700
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.049998662243150686em"
    }
  }, "6"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 94.9,
    y: 0
  }, "6%"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveOnCampusStat);
export default __webpack_public_path__ + "static/media/live-on-campus-stat.738edcf7878093a034eba4227f4d5b23.svg";
export { ForwardRef as ReactComponent };